import styled, { css } from 'styled-components';

export const CardWrap = styled.div`
    width: 100%;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 4px 8px 0 rgba(43, 53, 86, 0.05);
`;

function titleSize({ cardSize }) {
    switch (cardSize) {
        case 'lg': {
            return css`
                height: 80px;
                padding: 5px 40px;
            `;
        }
        default:
            return css`
                height: 60px;
                padding: 5px 30px;
            `;
    }
}
export const Header = styled.div`
    ${titleSize};
    display: flex;
    align-items: center;
    color: var(--color-text-700);
    border-bottom: 1px solid #e5ebf0;
`;

function footerSize({ cardSize }) {
    switch (cardSize) {
        case 'lg': {
            return css`
                padding: 15px 40px 40px;
            `;
        }
        default:
            return css`
                padding: 15px 30px;
            `;
    }
}

export const Footer = styled.div`
    ${footerSize};
    border-top: 1px solid #e5ebf0;
`;

export const CardBody = styled.div`
    padding: ${({ cardSize }) => (cardSize === 'lg' ? '40px' : '25px')};

    .title {
        margin-top: 0;
    }

    p:first-of-type {
        margin-top: 0;
    }
    p:last-of-type {
        margin-bottom: 0;
    }
`;

export const Cover = styled.img`
    width: 100%;
    display: block;
    border-radius: 5px 5px 0 0;
    height: ${({ coverHeight }) => coverHeight};
`;
